import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  isSuperAdmin: false
}

export const superAdminSlice = createSlice({
  name: 'superAdmin',
  initialState,
  reducers: {
    setIsSuperAdmin: (state, action) => {
      state.isSuperAdmin = action.payload
    },
    resetSuperAdmin: () => initialState
  }
})

export const {setIsSuperAdmin, resetSuperAdmin} = superAdminSlice.actions

// Selectors
export const selectIsSuperAdmin = (state) => state.superAdmin.isSuperAdmin

export default superAdminSlice.reducer
